module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-700.7432889d.ttf";